import CrudController from "./crud_controller";

export default class extends CrudController {

  static targets = [];

  LIST_TYPES = [];

  connect() {

  }
}